<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <div class="searchTitle display_between">
        <div class="searchTitleText">
          期刊浏览
        </div>
        <div class="searchInput">
          <img src="/image/icon/fangdajinghui.png" />
          <input type="text"
                 name=""
                 id=""
                 value="" />
        </div>
      </div>
      <div class="timezhou">
        <div class="yearWrap">
          <span :class="{ yearActive: timelineIndex == 0 }">2030</span>
          <span :class="{ yearActive: timelineIndex == 10 }">2020</span>
          <span>2010</span>
          <span>2000</span>
        </div>
        <div class="lineWrap">
          <span class="linelv"
                :class="{ activelinelv: timelineIndex == 0 }"></span>
          <span class="linelv"
                :class="{ activelinelv: timelineIndex == 10 }"></span>
        </div>
      </div>
      <div class="positionBtn marginBottom40">
        <swiper :options="swiperOption"
                ref="mySwiper"
                class="imgBanner"
                @slideChangeTransitionEnd="slideChange($event)">
          <swiper-slide v-for="(item, index) in treedata"
                        :key="'0' + index">
            <a href="javascript:;"
               :class="{ timeItem_active: yearTagindex == item.label }"
               class="timeItem "
               @click="yearClick(item, 1)">
              {{ item.label }}
            </a>
          </swiper-slide>
        </swiper>
        <div class="prevbutton">&lt;</div>
        <div class="nextbutton">&gt;</div>
      </div>
      <div class="number">
        <table>
          <tr v-for="(item, index) in periods"
              :key="'0' + index">
            <!-- <td :class="{activeTd:periodsTagindex=='0'+index+index2}" v-for="(qitem,index2) in item" :key="'0'+index+index2" @click="periodsTag(item,index,index2)">
                            <a href="javascript:void(0);">{{qitem.label}}</a>
                        </td> -->
            <td :class="{ activeTd: periodsTagindex == '0' + index + qitem.label }"
                v-for="(qitem, index2) in item"
                :key="'0' + index + index2"
                @click="periodsTag(qitem, index, qitem.label)">
              <a href="javascript:;">第{{ qitem.label }}期</a>
            </td>
          </tr>
        </table>
      </div>
      <div class="taggleMain">
        <div class="titleTageWrapSpe">
          <span class="tagTitle"
                :class="{ tagTitleActive: tagMenuindex == 0 }"
                @click="tagMenu(0)">最近更新</span>
          <span class="tagTitle"
                :class="{ tagTitleActive: tagMenuindex == 1 }"
                @click="tagMenu(1)">{{ newyear }}</span>
        </div>
        <div class="listWrap">
          <!-- <div class="WrapRectangle">
                        <div class="rectangle rectangleActive">
                            <div class="trangle">
                            </div>
                            论著
                        </div>
                        <div class="rectangle">
                            <div class="trangle">
                            </div>
                            综述
                        </div>
                        <div class="rectangle">
                            <div class="trangle">
                            </div>
                            学术探讨
                        </div>
                        <div class="rectangle">
                            <div class="trangle">
                            </div>
                            实验研究
                        </div>
                    </div> -->
          <a href="javascript:;"
             class="listItem"
             v-for="(item, index) in volArticleList"
             :key="'0' + index">
            <div class="listItemTitle"
                 @click="tojourdetail(item)">[{{ item.nian }}年{{ item.qi }}期] {{ textFormat(item.biaoTi_CN) }}</div>
            <div class="listItemSub"
                 v-html="item.zuoZhe_CN"
                 @click="tojourdetail(item)">
              <!-- {{ textFormat(item.zuoZhe_CN) }} -->
            </div>
            <div class="display_between opera">
              <div>
                <div v-if="item.guanJianCi_CN">
                  <span class="marginRight5 grayColor">关键词:</span>
                  <span class="gree_block"
                        v-for="(itemN, indexn) in biaoqianFormat(item.guanJianCi_CN).split(',')"
                        :key="'0' + indexn"
                        @click="onsearch(delHtmlTag(itemN))">
                    {{ delHtmlTag(itemN) }}
                  </span>
                </div>
              </div>
              <div class="inforshow">
                <span class="marginRight20">
                  下载次数:
                  <span style="color: #469A97;">{{ item.pdF_XiaZaiCiShu }}</span>
                </span>
                <span>
                  阅读次数:
                  <span style="color: #469A97;">{{ item.zhaiYaoLiuLanCiShu }}</span>
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage';
import lodash from 'lodash';

export default {
  name: 'litelist2',
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper;
    },
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 10,
        slidesPerGroup: 10,
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton',
          disabledClass: 'my-button-disabled',
        },
      },
      timelineIndex: 0,
      // 期数
      periods: [],
      // 年份激活index
      yearTagindex: 0,
      // 期数激活index
      periodsTagindex: '000',
      // 菜单激活index
      tagMenuindex: 1,
      // 页数激活index
      pageIndex: 1,
      pageAll: 8,
      apiData: {
        yearNum: {},
        periods: {},
        newslist: {},
      },
      /**tianlianpei */
      yearnav: 0,
      issuenav: 0,
      treedata: [],
      treechildren: [],
      newArticleList: [],
      volArticleList: [],
      isActive: true,
      years: '', //年
      issue: '', //期
      newyear: '', //最新年期
    };
  },
  created () {
    this.GetArticleBrowseInfo();

    this.issue = this.$route.query.qi;
    this.newyear = this.$route.query.nian + '年' + this.issue + '期';
    this.periodsTagindex = '0' + (Math.ceil(this.issue / 18) - 1) + this.issue;
    this.yearTagindex = this.$route.query.nian;
    this.years = this.$route.query.nian;

    this.GetArticleInfoPageList(this.years, this.issue);
  },
  methods: {
    // 首页
    firstPage () {
      this.pageIndex = 1;
    },
    // 尾页
    lastPage () {
      this.pageIndex = this.pageAll;
    },
    // 页数点击
    pageSet (index) {
      this.pageIndex = index;
    },
    // 上一页
    prePage () {
      if (this.pageIndex > 1) {
        this.pageIndex--;
      }
    },
    // 下一页
    nextPage () {
      if (this.pageIndex < this.pageAll) {
        this.pageIndex++;
      }
    },
    // 菜单切换
    tagMenu (index) {
      this.tagMenuindex = index;
      this.volArticleList = [];
      if (index == 0) {
        this.volArticleList = this.newArticleList;
      } else {
        this.GetArticleInfoPageList(this.years, this.issue);
      }
      // 根据index0、1更新列表数据
    },
    // 期数切换
    periodsTag (item, index, index2) {
      this.years = item.plabel;
      this.issue = item.label;
      this.newyear = item.plabel + '年' + this.issue + '期';

      this.periodsTagindex = '0' + index + index2;
      // 根据item更新列表数据
      this.volArticleList = [];

      this.GetArticleInfoPageList(item.plabel, item.label);
    },
    slideChange () {
      this.timelineIndex = this.swiper.activeIndex;
    },
    // 年份点击
    yearClick (data1, type) {
      this.years = data1.label;
      if (type == 0) {
        this.newyear = data1.label + '年' + this.issue + '期';
      } else {
        this.periodsTagindex = '001';
        this.newyear = data1.label + '年1期';
        this.GetArticleInfoPageList(data1.label, '1');
      }
      this.yearTagindex = data1.label;

      // 根据年份year获取数据
      this.periods = [];
      this.periods = data1.children;
      this.periods = lodash.chunk(this.periods, 18);
    },

    /**tianlianpei */
    biaoqianFormat (val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '')
        .replace(/&nbsp;/g, '')
        .replace(/\|/g, '；');
    },
    textFormat (val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '')
        .replace(/&nbsp;/g, '');
    },
    clkissuenav (item) {
      this.issuenav = item.label;
      this.newyear = item.plabel + '年' + item.label + '期';
      this.GetArticleInfoPageList(item.plabel, item.label);
    },
    /**最新更新切换列表 */
    clkhead (index) {
      if (index == 1) this.isActive = true;
      else this.isActive = false;
    },
    /**获取期刊浏览数据 */
    GetArticleBrowseInfo () {
      let _this = this;
      _this.httphelper.get('/api/ArticleApi/GetArticleInfoAnnualPageList').then(res => {
        if (res.code == 200) {
          //年卷树结构数据
          _this.treedata = res.data.articleSelectTree || null;
          //最新一期数据
          _this.newArticleList = res.data.gpSiteArticleInfoViews || null;
          //默认选中年
          let index = _this.treedata.findIndex(function (data) {
            return data.label == _this.years;
          });
          _this.yearnav = index;
          _this.issuenav = _this.issue;
          _this.yearClick(_this.treedata[index], 0);
          _this.GetArticleInfoPageList(_this.years, _this.issue);
        }
      });
    },
    /**根据年，期获取文献数据 */
    GetArticleInfoPageList (year, period) {
      let _this = this;
      _this.$loading.show({
        text: 'loading....',
        textStyle: {
          fontSize: '18px',
          color: '#0b8686',
        },
      });
      _this.httphelper
        .post('/api/ArticleApi/GetArticleInfoPageList', {
          year: year,
          period: period,
          id: 0,
          keywords: '',
          recommendNumber: 0,
        })
        .then(res => {
          _this.$loading.hide();
          if (res.data.code == 200) {
            //年卷树结构数据
            _this.volArticleList = res.data.data.gpSiteArticleInfoViews || null;
          }
        });
    },
    /**文献跳转详情 */
    tojourdetail (item) {
      var param = { nian: item.nian, qi: item.qi };
      localStorage.setItem('magazinejournal_param_' + item.nian, JSON.stringify(param));
      const { href } = this.$router.resolve({
        path: '/journal/magazinejournal/magazinejournaldetail',
        query: {
          nian: item.nian,
          qi: item.qi,
          id: item.id,
        },
      });
      // window.open(href, '_blank')
      window.location.href = href;
    },
    delHtmlTag (str) {
      return str.replace(/<[^>]+>/g, ''); //去掉所有的html标记
    },
    onsearch (keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords,
          tagIndexmuber: 'ShLiteList',
        },
      });
      window.open(href, '_blank');
    },
  },
  components: {
    breadcrumbPage,
  },
};
</script>

<style scoped>
.content {
    padding-top: 20px;
    flex: 1;
    padding-bottom: 60px;
}

.searchTitle {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
}

.searchTitleText {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #333;
}

.searchInput {
    position: relative;
}

.searchInput img {
    position: absolute;
    left: 10px;
    top: 23px;
}

.searchInput input {
    height: 30px;
    border: none;
    background: #ebebeb;
    width: 226px;
    outline: none;
    border-radius: 5px;
    padding-left: 30px;
    box-sizing: border-box;
}

.page_btn {
    color: #999;
    cursor: pointer;
    display: inline-block;
    width: 28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    border-radius: 30px;
    border: 1px solid #ccc;
}

.page_btn_active {
    background: #0b8686;
    color: #fff;
    border: 1px solid #0b8686;
}

.timeItem {
    width: 88px;
    height: 34px;
    font-size: 18px;
    text-align: center;
    line-height: 34px;
    font-weight: bold;
    display: inline-block;
    color: #333;
    border-radius: 7px 0px 7px 0px;
}

.timeItem_active {
    background: linear-gradient(90deg, #3a9a9b, #007476);

    color: #fff;
}

.number {
    margin-top: 20px;
}

.number table {
    border-collapse: collapse;
    width: 100%;
    /* 	border: 1px solid #ddd; */
}

.number table td {
    border: 1px solid #dee2e6;
    height: 30px;
    text-align: center;
    cursor: pointer;
}

.number table td a {
    width: 100%;
    height: 100%;
    line-height: 30px;
    display: inline-block;
}

.activeTd a {
    background-color: #0b8686;
    color: #fff;
}

/* 列表切换部分 */
/* 气泡框 */

.rectangle {
    position: relative;
    padding: 10px 0;
    width: 124px;
    text-align: center;
    cursor: pointer;
    color: #0b8686;
    display: inline-block;
    font-weight: bold;
}

.rectangleActive {
    background: #0b8686;
    color: #fff;
}

.rectangle ~ .rectangle::before {
    content: '|';
    position: absolute;
    left: -3px;
    color: #ddd;
}

.rectangle .trangle {
    position: absolute;
    top: 38px;
    right: 45%;
    width: 0;
    height: 0;
    font-size: 0;
    border: solid 8px;
    border-color: #0b8686 transparent transparent transparent;
    display: none;
}

.rectangleActive .trangle {
    display: inline-block;
}

.taggleMain {
    padding-top: 40px;
}

.titleTageWrapSpe {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 40px;
}

.tagTitle {
    display: inline-block;
    height: 100%;
    font-size: 18px;
    cursor: pointer;
    font-weight: bold;
    position: relative;
    margin-right: 20px;
}

.tagTitle ~ .tagTitle::before {
    content: '/';
    margin: 0 14px;
    color: #ddd;
    position: absolute;
    left: -28px;
}

.tagTitleActive {
    border-bottom: 1px solid #0b8686;
    color: #0b8686;
}

/* 列表 */
.listItem {
    padding: 20px 0;
    border-bottom: 1px solid #ddd;
    display: block;
}

.listItem:last-child {
    border-bottom: none;
}

.listItemTitle {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    position: relative;
}

.listItemSub {
    font-size: 16px;
    color: #ccc;
}

.opera {
    margin-top: 10px;
}

.gree_block,
.red_block,
.blue_block {
    display: inline-block;
    padding: 4px 5px 2px 5px;
    font-size: 12px;
    margin-right: 5px;
    height: 20px;
}

.gree_block {
    border: 1px solid #469a97;
    color: #469a97;
}

.red_block {
    border: 1px solid #cc6d6e;
    color: #cc6d6e;
}

.blue_block {
    border: 1px solid #417393;
    color: #417393;
}

.inforshow {
    color: #ccc;
}

.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1240px;
}

.nextbutton,
.prevbutton {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 9%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton {
    right: -30px;
    left: auto;
}

.prevbutton {
    right: auto;
    left: -30px;
}

.swiper-slide {
    text-align: center;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

.timezhou {
    height: 1px;
    background: #bfbfbf;
    padding-left: 100px;
    margin: 30px 0;
    margin-top: 70px;
    line-height: 0;
    position: relative;
}

.yearWrap {
    font-size: 22px;
    position: absolute;
    top: -30px;
    left: 73px;
}

.yearWrap span {
    margin-right: 71px;
}

.yearActive {
    color: #0b8586;
}

.lineWrap {
    /*position: relative;*/
    float: left;
    margin-top: -3px;
}

.linelv {
    /*position: absolute;*/
    width: 122px;
    display: inline-block;
    height: 3px;
    /*background: #0B8586;*/
    position: relative;
}

.activelinelv {
    background: #0b8586;
}

.linelv:before {
    content: url(/image/icon/timelinenormal.png);
    position: absolute;
    top: -8px;
    left: -10px;
}

.linelv:after {
    content: url(/image/icon/timelinenormal.png);
    position: absolute;
    top: -8px;
    right: -10px;
}

.activelinelv:before {
    content: url(/image/icon/timelineactive.png);
    position: absolute;
    top: -8px;
    left: -10px;
    z-index: 10;
}

.activelinelv:after {
    content: url(/image/icon/timelineactive.png);
    position: absolute;
    top: -8px;
    right: -10px;
    z-index: 10;
}
</style>
